import React, { useState, useEffect, useRef } from "react";
import { FaSearch, FaHome, FaUserCircle, FaLaptopCode, FaDev, FaBars } from "react-icons/fa"; // Corrected import
import { FaUserGear } from "react-icons/fa6"; // Use this import
import { MdPermContactCalendar } from "react-icons/md";
import Logo from "../IMG/LOGO.gif";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for menu toggle
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const navigate = useNavigate();
  const headerRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the menu visibility
  };

  const searchItems = [
    { name: "Home", path: "/" },
    { name: "About Me", path: "/about-me" },
    { name: "Contact", path: "/contact" },
    { name: "Skills", path: "/skill" },
    { name: "Projects", path: "/projects" },
    { name: "Login / Admin", path: "/admin" },
    { name: "Docify Project", path: "/projects" },
    { name: "E-went Project", path: "/projects" },
    { name: "Shorts URL Shortner", path: "/projects" },
    { name: "House Of Marktechs", path: "/projects" },
    { name: "Foodiees", path: "/projects" },
    { name: "Ranter", path: "/projects" },
    { name: "In-went-tree", path: "/projects" },
    { name: "Aldaraz", path: "/projects" },
    { name: "Portfolio", path: "/projects" },
    { name: "Bootcamp Chatting App", path: "/projects" },
    { name: "ASK GPT Chatbot", path: "/projects" },
    { name: "Tokenly Auth", path: "/projects" },
    { name: "USSD Map", path: "/projects" },
    { name: "CCTV Violence Detection", path: "/projects" },
    { name: "PlantScrape UI/UX", path: "/projects" },
    { name: "Makerble UI/UX", path: "/projects" },
  ];

  const filteredItems = searchItems.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownVisible(e.target.value.length > 0);
  };

  const handleItemClick = (path) => {
    navigate(path);
    setIsDropdownVisible(false);
    setSearchTerm("");
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="bg-white shadow-md sticky top-0 z-50 " ref={headerRef}>
      {/* Top Bar */}
      <div className="flex items-center justify-between p-2 pl-4 pr-4 md:pl-32 md:pr-32">
        {/* Logo Section */}
        <div className="flex items-center space-x-1">
          <img src={Logo} alt="Logo" className="h-8 w-8 rounded-md" />
        </div>

        {/* Search Bar for Desktop */}
        <div className="hidden md:flex relative">
          <div className="flex items-center bg-search px-3 py-2 rounded-md w-64 ">
            <FaSearch className="mr-2" />
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              onFocus={() => { if (searchTerm.length > 0) setIsDropdownVisible(true); }}
              placeholder="Search"
              className="bg-transparent outline-none w-full text-sm text-gray-700"
            />
          </div>
          {isDropdownVisible && filteredItems.length > 0 && (
            <ul className="absolute top-10 left-0 z-50 w-full bg-white border border-gray-200 mt-1 rounded-md shadow-lg max-h-60 overflow-y-auto">
              {filteredItems.map((item, index) => (
                <li
                  key={index}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700 text-left"
                  onClick={() => handleItemClick(item.path)}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Hamburger Menu */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-secondary focus:outline-none">
            {isMenuOpen ? <FaBars size={24} className="rotate-90" /> : <FaBars size={24} />}

          </button>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6 ">
          <Link to="/" className="flex flex-col items-center text-secondary hover:text-primary">
            <FaHome size={20} />
            <span className="text-sm">Home</span>
          </Link>

          <Link to="/skill" className="flex flex-col items-center text-secondary hover:text-primary">
            <FaLaptopCode size={20} />
            <span className="text-sm">Skill</span>
          </Link>

          <Link to="/projects" className="flex flex-col items-center text-secondary hover:text-primary">
            <FaDev size={20} />
            <span className="text-sm">Projects</span>
          </Link>

          <Link to="/about-me" className="flex flex-col items-center text-secondary hover:text-primary">
            <FaUserCircle size={20} />
            <span className="text-sm">About Me</span>
          </Link>

          <div className="border text-secondary h-10 ml-4"></div>

          {/* Simple Contact Button */}
          <Link to="/Contact" className="flex flex-col items-center text-secondary hover:text-primary">
            <MdPermContactCalendar size={20} />
            <span className="text-sm">Contact</span>
          </Link>

          <Link to="/admin" className="flex flex-col items-center text-secondary hover:text-primary">
            <FaUserGear size={20} />
            <span className="text-sm">Login</span>
          </Link>


        </div>
      </div>

      {/* Mobile Sidebar Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-lg p-4 space-y-4">
          {/* Search Bar for Mobile */}
          <div className="relative w-full">
            <div className="flex items-center bg-search px-3 py-2 rounded-md w-full">
              <FaSearch className="mr-2" />
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                onFocus={() => { if (searchTerm.length > 0) setIsDropdownVisible(true); }}
                placeholder="Search Pages & Projects"
                className="bg-transparent outline-none w-full text-sm text-gray-700"
              />
            </div>
            {isDropdownVisible && filteredItems.length > 0 && (
              <ul className="absolute left-0 z-50 w-full bg-white border border-gray-200 mt-1 rounded-md shadow-lg max-h-48 overflow-y-auto">
                {filteredItems.map((item, index) => (
                  <li
                    key={index}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700 text-left"
                    onClick={() => handleItemClick(item.path)}
                  >
                    {item.name}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Mobile Navigation Links */}
          <Link to="/" onClick={toggleMenu} className="block text-secondary hover:text-primary">
            <FaHome size={20} className="inline-block mr-2" />
            Home
          </Link>

          <Link to="/skill" onClick={toggleMenu} className="block text-secondary hover:text-primary">
            <FaLaptopCode size={20} className="inline-block mr-2" />
            Skill
          </Link>

          <Link to="/projects" onClick={toggleMenu} className="block text-secondary hover:text-primary">
            <FaDev size={20} className="inline-block mr-2" />
            Projects
          </Link>

          <Link to="/about-me" onClick={toggleMenu} className="block text-secondary hover:text-primary">
            <FaUserCircle size={20} className="inline-block mr-2" />
            About Me
          </Link>

          {/* Mobile Contact Link */}
          <Link to="/Contact" onClick={toggleMenu} className="block text-secondary hover:text-primary">
            <MdPermContactCalendar size={20} className="inline-block mr-2" />
            Contact
          </Link>

          <Link to="/admin" onClick={toggleMenu} className="block text-secondary hover:text-primary">
            <FaUserGear size={20} className="inline-block mr-2" />
            Login
          </Link>


        </div>
      )}
    </div>
  );
}

export default Header;
